/**
 * Export Helper Utilities
 * Helper functions for downloading exported files
 */

export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const handleExport = async (exportFunction, filename, onSuccess, onError) => {
  try {
    const response = await exportFunction();
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    downloadFile(blob, filename);
    if (onSuccess) onSuccess();
  } catch (err) {
    if (onError) {
      onError(err.response?.data?.message || 'Export failed');
    }
  }
};
